import React from 'react'
import '../css/Success.css'
import { useNavigate } from 'react-router-dom';
import ReceiptPdf from './ReceiptPdf';

function SuccessPage() {
    let navigate = useNavigate();
    return (
        <div style={{marginTop:"13%"}}>
            <div class="white-2 animation-ctn d-flex flex-column justify-content-center align-items-center w-100 h-100">
                <div class="icon icon--order-success svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
                        <g fill="none" stroke="#22AE73" stroke-width="2">
                            <circle cx="77" cy="77" r="72" style={{ strokeDasharray: "480px, 480px", strokeDashoffset: "960px" }}></circle>
                            <circle id="colored" fill="#22AE73" cx="77" cy="77" r="72" style={{ strokeDasharray: "480px, 480px", strokeDashoffset: "960px" }}></circle>
                            <polyline class="st0" stroke="#fff" stroke-width="10" points="43.5,77.8 63.7,97.9 112.2,49.4 " style={{ strokeDasharray: "100px, 100px", strokeDashoffset: "200px" }} />
                        </g>

                    </svg>
                </div>
                <br />
                <h2>Payment Success</h2>
                <h3>Your appointment is booked</h3>

                <p>Pratick Gandhi</p>
                <p> Amount: INR 480.00</p>
                <p>GST Registration No: 29AAQCS49E10Z</p>
                <p>Ref Id: 9034333842</p>
                <div className="d-flex">
                <ReceiptPdf/>
                <div class="btn btn-indigo white-text mr-3 " onClick={() =>navigate("/") }> Back home</div>
                </div>
            </div>
        </div>
    )
}

export default SuccessPage